import React from 'react';
import { FormField } from '../../redux/types';
import BooleanInputField from '../base/BooleanInputField';
import { useTurnOffSaleOptionCallback } from '../hooks';
import s from './FixedPriceSectionToggle.scss';

interface Props {}

const FixedPriceSectionToggle: React.FC<Props> = () => {
  const turnOffSaleOption = useTurnOffSaleOptionCallback();

  return (
    <BooleanInputField
      name={FormField.SellAsFixed}
      labelClassName={s['label']}
      size="large"
      // we're setting these sell_as checkboxes automatically based on the inputs
      // they control, so we pull this out of keyboard control and hide from readers
      tabIndex={-1}
      aria-hidden
      onChange={isNowTrue => {
        if (!isNowTrue) {
          turnOffSaleOption(FormField.SellAsFixed);
        }
      }}
    />
  );
};

FixedPriceSectionToggle.displayName = 'FixedPriceSectionToggle';

export default FixedPriceSectionToggle;
